//#region IMPORT
import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { TextToSpeech } from '../../../Components/TextToSpeech';
import AiImg from '../../../Assets/Images/ai.svg';
import SpeechToText from '../../../Components/SpeechToText/SpeechToText';
//#endregion

function M_AIC_BASIC(props) {
  return (
    <Box sx={{ height: 'calc(100vh - 56px)', overflow: 'hidden' }}>
      <Stack sx={{ width: '100%', height: '100%' }}>
        <Box
          sx={{
            height: '100%',
            m: 2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <TextToSpeech
            text={props.aiCallText}
            onAudioPlayEnd={props.handleAudioPlayEnd}
            audioRef={props.audioRef}
            setTtsAudio={props.setTtsAudio}
            ttsAudio={props.ttsAudio}
          />
          <Box
            sx={{
              alignSelf: 'flex-start',
              ml: 2.5,
              mt: '50px',
              mb: '-20px',
              zIndex: 10,
            }}
          >
            <Box
              component="img"
              src={AiImg}
              alt="Ai 이미지"
              sx={{ width: 100, height: 100 }}
            />
          </Box>
          <Box
            sx={{
              pt: '44px',
              pb: '36px',
              px: '16px',
              mb: 4,
              width: '100%',
              backgroundColor: '#FFFFFF',
              borderRadius: '20px',
              boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
            }}
          >
            <Typography fontSize={18} fontWeight={550}>
              {props.aiCallMessage}
            </Typography>
          </Box>
          <Box
            sx={{
              mt: 'auto',
              mb: 5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <SpeechToText
              ref={props.speechToTextRef}
              onTranscriptionChange={props.handleTranscriptionChange}
              streamRef={props.streamRef}
              mediaRecorderRef={props.mediaRecorderRef}
              setTtsAudio={props.setTtsAudio}
              ttsAudio={props.ttsAudio}
            />
          </Box>
        </Box>
      </Stack>
    </Box>
  );
}

export default M_AIC_BASIC;
